import React from 'react';
import { motion } from 'framer-motion';

const TarotCard = ({ card, isRevealed = false }) => {
  return (
    <div className="relative w-full aspect-[7/12]" data-testid="tarot-card">
      <motion.div
        className="w-full h-full"
        initial={false}
        animate={{ rotateY: isRevealed ? 180 : 0 }}
        transition={{ duration: 0.6, ease: 'easeInOut' }}
        style={{ transformStyle: 'preserve-3d' }}
      >
        {/* Card Back */}
        <div
          className="absolute inset-0 rounded-lg overflow-hidden shadow-lg"
          style={{
            backfaceVisibility: 'hidden',
            transform: 'rotateY(0deg)',
          }}
        >
          <img
            src="https://static.prod-images.emergentagent.com/jobs/adfa46bb-e966-4f22-bd70-893aead51158/images/c471dd7961f12c3a7f19238e968e842d14395c8d0bc239d36f238efb8ef6be4b.png"
            alt="Card back"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Card Front */}
        <div
          className="tarot-neon-front absolute inset-0 rounded-lg overflow-hidden bg-[#0a0a14]"
          style={{
            backfaceVisibility: 'hidden',
            transform: `rotateY(180deg) ${card?.is_reversed ? 'rotate(180deg)' : ''}`,
          }}
        >
          {card?.image_url ? (
            <img
              src={card.image_url}
              alt={card?.name}
              className="w-full h-full object-contain"
              loading="lazy"
            />
          ) : (
            <div className="w-full h-full flex flex-col items-center justify-center p-2 bg-gradient-to-b from-[#0F0F11] to-[#1a1a1c] text-center">
              <p className="text-xs font-heading text-[#D4AF37]">{card?.name}</p>
            </div>
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default TarotCard;
